// extracted by mini-css-extract-plugin
module.exports = {"icons":"ContactIcons_icons__1w2-s"};